import type { JSX } from 'react';

import { ScrollContainer } from 'src/app/shared/components/ScrollContainer';

import { PromotionCard } from './components/PromotionCard';
import { useRecentPromotionsList } from './hooks/useRecentPromotionsList';

export function RecentPromotionsList(): JSX.Element | null {
	const { data } = useRecentPromotionsList();

	if (data.promotions.length === 0) return null;

	return (
		<section aria-label="recent-promotion-list">
			<ScrollContainer
				as="div"
				className="pl-4 last:mr-4 md:pl-12 md:last:mr-12 [&>#scroll-container-list]:grid-cols-[repeat(auto-fit,_200px)] [&>div>button]:hidden md:[&>div>button]:inline-block"
			>
				{data.promotions.map((promotion) => (
					<PromotionCard promotion={promotion} key={`promotion-card-${promotion.id}`} />
				))}
			</ScrollContainer>
		</section>
	);
}
